export class ChatRoleEnum {
  public static USER = 'USER';
  public static ADMIN = 'ADMIN';
}